/* Sunvolt – subtil, mjuk fade-in av sektioner när de scrollas in.
   Robust: hidden-läget aktiveras BARA om JS kör + rörelse tillåts, och allt
   avslöjas ändå via säkerhetsnät (timeout) + omedelbart för det som redan syns.
   Inget kan därför fastna "tomt". */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Utan IntersectionObserver eller med reduce-motion: lämna allt synligt.
  if (!('IntersectionObserver' in window) || reduce) return;

  // Av/på styrs av brytaren i Temainställningar → head-scriptet i theme.liquid sätter
  // klassen (före paint). Är den inte satt är effekten avstängd → gör inget.
  if (!root.classList.contains('sv-reveal-on')) return;

  function start() {
    var nodes = document.querySelectorAll('#MainContent > .shopify-section, [data-sv-reveal]');
    if (!nodes.length) { root.classList.remove('sv-reveal-on'); return; }

    // FAS 1 (direkt): de två första sektionerna avslöjas alltid – de är ovanför
    // vikningen på alla skärmar. Rect-mätning duger INTE här: vid DOMContentLoaded
    // är layouten ofta kollapsad (bilder utan höjd) så ALLA sektioner mätte som
    // "synliga" → allt avslöjades direkt och inga scroll-animationer återstod.
    nodes[0].classList.add('sv-in');
    if (nodes[1]) nodes[1].classList.add('sv-in');
    var rest = Array.prototype.slice.call(nodes, 2);
    if (!rest.length) return;

    // FAS 2 (när layouten satt sig – window.load eller 700 ms, det som kommer först):
    // nu är rect-måtten sanna → avslöja det som faktiskt syns, observera resten.
    function phase2() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Levande-signal: IO kör sin callback direkt vid observe (även utan träff).
      // Kommer ingen callback alls är observern död i miljön → nätet tar över.
      var ioAlive = false;
      var io = new IntersectionObserver(function (entries) {
        ioAlive = true;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sv-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

      rest.forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.9) {
          el.classList.add('sv-in');
        } else {
          io.observe(el);
        }
      });

      // Säkerhetsnät ENDAST om observern aldrig levererar (trasig miljö).
      // Ett blint nät avslöjade tidigare allt efter 2,5 s → den som läste heron
      // en stund och sedan scrollade såg aldrig några animationer.
      setTimeout(function () {
        if (ioAlive) return;
        rest.forEach(function (el) { el.classList.add('sv-in'); });
      }, 3000);
    }

    var started = false;
    function go() { if (started) return; started = true; phase2(); }
    if (document.readyState === 'complete') go();
    else {
      window.addEventListener('load', go, { once: true });
      setTimeout(go, 700);
    }
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Sunvolt – mjuk in-toning av bilder som INTE redan är laddade (cachade rör vi inte → ingen
   flash). Minskar "pop" när bilder kommer in. Respekterar reduced-motion. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function fade(img) {
    if (!img || img.dataset.svFade) return;
    if (img.complete && img.naturalWidth) return;           // redan klar → rör inte
    /* Bilder i DOLDA behållare (cart-drawer, modaler, stängda paneler) hoppas över:
       de är loading="lazy" → webbläsaren laddar dem aldrig medan de är dolda → load-
       eventet kommer aldrig → opacity:0 hade blivit PERMANENT (osynlig produktbild i
       varukorgs-drawern). Ingen fade behövs där; de ligger ändå utanför synfältet. */
    if (!img.getClientRects().length) return;
    img.dataset.svFade = '1';
    img.classList.add('sv-img-fade');
    var reveal = function () { img.classList.add('is-in'); };
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
    if (img.complete) reveal();                              // hann bli klar mellan check & lyssnare
    setTimeout(reveal, 3000);                                // säkerhetsnät: aldrig permanent osynlig
  }
  function run() { document.querySelectorAll('img').forEach(fade); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Sunvolt – header: (1) aktiv nav-markering på nuvarande sida (Dawn sätter inte aria-current här),
   (2) krymp headern vid scroll. */
(function () {
  function initNav() {
    var path = location.pathname.replace(/\/+$/, '') || '/';
    /* Bara TOPP-nivå nav (ej mega-meny-länkar inuti) */
    var links = [].slice.call(document.querySelectorAll('.header__menu-item[href], .menu-drawer__menu-item[href]'));
    links.forEach(function (a) { try { a._svlp = new URL(a.href, location.origin).pathname.replace(/\/+$/, '') || '/'; } catch (e) { a._svlp = null; } });
    // Exakt träff vinner; annars längsta "förälder-sökväg" (t.ex. /collections markerar Alla produkter på /collections/all); root '/' bara på startsidan.
    var winPath = null, bestLen = -1;
    links.forEach(function (a) { if (a._svlp === path) winPath = path; });
    if (!winPath) { links.forEach(function (a) { var lp = a._svlp; if (lp && lp !== '/' && path.indexOf(lp + '/') === 0 && lp.length > bestLen) { bestLen = lp.length; winPath = lp; } }); }
    if (!winPath && path === '/') winPath = '/';
    if (winPath) { links.forEach(function (a) { if (a._svlp === winPath) { a.classList.add('sv-nav-active'); a.setAttribute('aria-current', 'page'); } }); }
    var hdr = document.querySelector('.header-wrapper');
    if (hdr) {
      var shrink = function () { hdr.classList.toggle('sv-header-shrunk', window.scrollY > 60); };
      shrink();
      window.addEventListener('scroll', shrink, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNav);
  else initNav();
})();
